import xss from 'xss'

// ==================== XSS 过滤工具 ====================
// 用途：所有 v-html 渲染后端可控内容前必须过过滤，防存储型 XSS。
// 用法（main.js 已注册到 Vue.prototype）：
//   默认文本：v-html="$filterXSS(text)"
//   富文本：  v-html="$filterXRichtext(content)"

// 默认档：列表单元格 / 标签 / 普通文本——只留基础排版标签，style 一律剥离
const DEFAULT_WHITELIST = {
  span: ['class'], b: [], strong: [], em: [], i: [], u: [], s: [], br: [],
  p: ['class'], div: ['class'],
  a: ['href', 'title', 'target', 'rel'],
  img: ['src', 'alt', 'title', 'width', 'height']
}

// 富文本档：通知/公告正文——保留常用排版标签与内联样式（style 值由 xss 内置 CSS 消毒剥离危险内容）
const RICH_WHITELIST = {
  span: ['class', 'style'], div: ['class', 'style'], p: ['class', 'style'],
  b: [], strong: [], em: [], i: [], u: [], s: [], del: [], sub: [], sup: [], small: [], big: [], br: [], hr: [],
  h1: ['class', 'style'], h2: ['class', 'style'], h3: ['class', 'style'],
  h4: ['class', 'style'], h5: ['class', 'style'], h6: ['class', 'style'],
  blockquote: ['class', 'style'], code: [], pre: ['class'],
  ul: ['class', 'style'], ol: ['class', 'style'], li: ['class', 'style'],
  table: ['class', 'style', 'border', 'cellpadding', 'cellspacing'],
  thead: [], tbody: [], tr: [], td: ['class', 'style', 'colspan', 'rowspan'], th: ['class', 'style', 'colspan', 'rowspan'],
  a: ['href', 'title', 'target', 'rel'],
  img: ['src', 'alt', 'title', 'width', 'height', 'style']
}

const DEFAULT_OPTIONS = {
  stripIgnoreTag: true,
  stripIgnoreTagBody: ['script', 'style'],
  whiteList: DEFAULT_WHITELIST
}

const RICH_OPTIONS = {
  stripIgnoreTag: true,
  stripIgnoreTagBody: ['script', 'style'],
  whiteList: RICH_WHITELIST
}

export function filterXSS (content) {
  if (content === null || content === undefined) return ''
  return xss(String(content), DEFAULT_OPTIONS)
}

export function filterXRichtext (content) {
  if (content === null || content === undefined) return ''
  return xss(String(content), RICH_OPTIONS)
}
